import { clientInstance } from "../config/config"

export const getMyEmployeesAPI = () =>
  clientInstance.get("/business/employees")

export const createInvitationAPI = (data) =>
  clientInstance.post("/business/employees/invitation", data)

export const createEmployeeWithUsernameAPI = (data) =>
  clientInstance.post("/business/employees/create-username", data)

export const updateEmployeeAPI = (studentId, data) =>
  clientInstance.patch(`/business/employees/${studentId}`, data)

export const freezeEmployeeAPI = (studentId) =>
  clientInstance.put(`/business/employees/${studentId}/freeze`)

export const deleteEmployeeAPI = (studentId) =>
  clientInstance.delete(`/business/employees/${studentId}`)

export const resendInvitationAPI = (invitationId) =>
  clientInstance.post(`/business/employees/invitation/${invitationId}/resend`)

export const getEmployeeDetailsAPI = (studentId) =>
  clientInstance.get(`/business/employees/${studentId}/details`)

export const getBusinessAPI = () =>
  clientInstance.get("/business")

export const updateBusinessAPI = (data) =>
  clientInstance.patch("/business", data)
